import {Injectable} from '@angular/core';
import {PaginatorService} from "@shared/api/services/paginator.service";
import {firstValueFrom, map} from "rxjs";
import {Clinician} from "@shared/api/models/query/user.model";
import {ClinicianAvailability} from "@shared/api/models/query/clinician.model";

@Injectable({
    providedIn: 'root'
})
export class CliniciansService extends PaginatorService<Clinician> {

    protected override get domainEntity() {
        return 'clinicians';
    };

    async listByDepartment(departmentId: number): Promise<Clinician[]> {
        const result = this.http.get<any>(
            `${this.urlToEntity}?departmentId=${departmentId}&sort=firstName,lastName&size=999`
        ).pipe(
            map((response) => response?.data ?? [])
        );
        return firstValueFrom(result);
    }

    async getAvailability(id: number, startDate: string, endDate: string, view: string): Promise<ClinicianAvailability[]> {
        let result = this.http.get<any>(this.urlToEntity + '/' + id + '/availability?view=' + view + '&startDate=' + startDate + '&endDate=' + endDate)
            .pipe(
                map((response) => {
                    return response.data;
                })
            )
        return firstValueFrom(result)
    }
}
